function validaUrlYoutube(url) {
  let regexDealer = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  return !!(url.match(regexDealer));
}

export default validaUrlYoutube;